import React, { PureComponent } from "react"
import { env } from "../../constants"


/* Component Hit */
class Hit extends PureComponent {

    render = () => {
        const { onClick } = this.props
        return (
            <div onClick={() => onClick()} className="game-button hit-button">
                <img src={`${env.endpoint}/images/buttons/hit.png`} alt="hit" />
                <p>HIT</p>
            </div>
        )
    }

}

export default Hit